'use client';

import { c as _c } from "react/compiler-runtime";
import { TanStackDevtools } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
export const TanstackDevTools = () => {
  const $ = _c(1);
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TanStackDevtools plugins={[{
      name: "TanStack Query",
      render: <ReactQueryDevtoolsPanel />
    }, formDevtoolsPlugin()]} data-sentry-element="TanStackDevtools" data-sentry-component="TanstackDevTools" data-sentry-source-file="devtools.tsx" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};